module.exports = __webpack_public_path__ + "media/images/home-banners/quino-al-387923-unsplash-cc710a86ea3c288b940ea034814e8033.jpg";